<template>
    <div>
        <el-row>
            <h2>出库单管理</h2>
        </el-row>
        <el-row>
            <el-form v-model="searchForm" ref="searchForm" :inline="true" style="padding: 0;margin: 0">
                <el-col :span="5">
                    <el-form-item label="项目点：">
                        <el-select v-model="searchForm.PROJECT" placeholder="请选择" filterable>
                            <el-option
                                    v-for="item in projects"
                                    :key="item.value"
                                    :label="item.NAME"
                                    :value="item.ID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-button @click="searchStorageDocument">搜索</el-button>
                </el-col>
            </el-form>
        </el-row>
        <el-row>
            <el-col>
                <el-table :data="tableData" stripe border>
                    <el-table-column label="序号" type="index"></el-table-column>
                    <el-table-column label="盘库但号" prop="DELIVER_CODE"></el-table-column>
                    <el-table-column label="盘库时间" prop="DELIVER_DAY"></el-table-column>
                    <el-table-column label="档口" prop="DK_NAME"></el-table-column>
                    <el-table-column label="负责人" prop="DK_USER_NAME"></el-table-column>
                    <el-table-column label="状态" prop="STATUS"></el-table-column>
                    <el-table-column label="产品数量" prop="ALL_PRODUCT_COUNT"></el-table-column>
                    <el-table-column label="总金额" prop="TOTAL_FEE"></el-table-column>
                    <el-table-column label="状态" prop="STATUS">
                        <template slot-scope="scope">
                            {{showLable(scope.row)}}
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-edit" size="small" @click="openDetail(scope.row)">查看</el-button>
                            <el-button type="text" icon="el-icon-edit" size="small" @click="checkDocument(scope.row)">审批通过</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
                               layout="total, prev, pager, next, jumper" :total="totalNum" style="float: right">
                </el-pagination>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import http from '@/api/base/http';

export default {
  data() {
    return {
      searchForm: {},
      projects: [],
      currentPage: 1,
      totalNum: 0,
      pageSize: 10,
      tableData: [],
    };
  },
  created() {
    this.queryProject();
  },
  methods: {
    queryProject() {
      const params = {
        SERVICE_ID: '10001',
        OTYPE: 8,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        TC_ID: sessionStorage.getItem('companyId'),
      };
      http.post(params).then((result) => {
        this.projects = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    searchStorageDocument() {
      const params = {
        PROJECT_ID: this.searchForm.PROJECT,
        TC_ID: sessionStorage.getItem('companyId'),
        PAGEINDEX: 0,
        PAGESIZE: 10,
        SERVICE_ID: '11002',
        OTYPE: 1,
      };
      http.post(params).then((result) => {
        if (result[0].OP_ROLE == '') {
          this.tableData = [];
          this.totalNum = 0;
        } else {
          this.tableData = result[0].OP_ROLE;
          this.totalNum = result[0].TOTAL_COUNT;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange() {
      this.searchStorageDocument();
    },
    openDetail(row) {
      this.$router.push({ name: 'storageDetail', params: { id: row.ID } });
      sessionStorage.setItem('projectId', this.searchForm.PROJECT);
    },
    checkDocument(row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '11002',
            OTYPE: 5,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            DELIVER_ID: row.ID,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '通过审批成功', type: 'success' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    showLable(row) {
      if (row.STATUS == 1) {
        return '未审批';
      }
      return '审批通过';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/storageDocument.vue